export default "__VITE_ASSET__DeRUsAuf__"